<template>
  <div class="mainPage">
    <div class="header_banner">
      <!-- <header>
        <div class="center">
          <div class="right">
            <div v-if="!isLogin" class="loginCon">
              <span @click="toLogin()">{{ $t("message.login") }}</span> /
              <span @click="toLogin()">{{ $t("message.register") }}</span>
            </div>
            <div v-if="isLogin" class="loginCon">
              <span
                ><span class="username">{{ user.username }}</span
                ><span @click="toLogOut()">{{ $t("message.logout") }}</span>
              </span>
            </div>
          </div>
        </div>
      </header> -->
      <div class="infoCon">
        <div class="centerBg">
          <img
            src="../img/chineseCultureVideoExhibition2025/new_2024/logo_title.png"
            alt=""
            class="left"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftBox">
        <div class="box">
          <div
            class="titleBox"
            v-for="(item, index) in subject_info"
            :key="item.id"
            :class="{ active: active === index }"
            @click="goAnchor('t' + item.id)"
          >
            <div
              class="title"
            >
              <span class="title_cn">{{ item.name }}</span>
              <span class="title_en">{{ item.name_en }}</span>
            </div>

            <img
              src="../img/chineseCultureVideoExhibition2025/icon1.png"
              alt=""
              class="icon"
            />
          </div>
        </div>
      </div>

      <div class="rightBox" v-if="!showDetail">
        <div class="projectProfile">
          <div class="box">
            <div class="text">
              中国神话故事是中华文化宝库中璀璨的明珠。我们推出2025“魅力中文”精品节目展播，带您观赏中央广播电视总台制作的《美猴王》《中国神话》《自古英雄出少年之哪吒传奇》，了解中国古人对世界的想象与智慧，在《重回永乐大典》《一字千年》《千古名篇》等节目中感受中文的独特魅力。
            </div>
            <div class="text2">
              Chinese mythological stories are shining pearls in the treasure trove of Chinese culture. We have launched the 2025 "Glamorous Chinese" Premium Programs broadcast, featuring CMG productions such as The Monkey King, Chinese Mythology, and The Rebirth Of The Young Hero Nezha. These works will take you on a journey to explore the ancient Chinese imagination and wisdom about the world. Additionally, through programs like Back to the Yongle Dadian, The Living Lines, and Exploring the Timeless Beauty of Poetry through the Ages, you can experience the unique charm of the Chinese language.
            </div>
          </div>
        </div>

        <div
          class="classBox"
          v-for="subject in subject_info"
          :key="subject.id"
          :ref="subject.id"
        >
          <div
            class="classBox1"
            :id="'t' + subject.id"
          >
            <!-- <img :src="subject.extra.schoolLogo" alt="" class="title" /> -->
            <div class="series_info">
              <div class="info_left">
                <div class="cloud_con">
                  <div class="serise_icon_con">
                    <img :src="subject.image_url" alt="" class="look_detail_icon">
                  </div>
                </div>
                <div class="name_con">
                  <p class="cn">{{ subject.name }}</p>
                  <p class="en">{{ subject.name_en }}</p>
                </div>
              </div>
              <img src="../img/chineseCultureVideoExhibition2025/look_detail.png" alt="" class="look_detail_icon" @click="goDetail(subject, 0)">
            </div>
            <div v-if="subject.type == 1">
              <div class="text_cn">
                {{ subject.describe }}
              </div>
              <div class="text_en">
                {{ subject.describe_en }}
              </div>
              <div class="swiper_con">
                <swiper :options="swiperOption" ref="mySwiper" class="swiper">
                  <swiper-slide
                    v-for="(v, index) in subject.courseList"
                    :key="index"
                    style="width: 3.5rem;"
                  >
                    <div
                      class="video_con"
                      :data-info="v.name"
                      @click="goDetail(subject, index)"
                    >
                      <div class="video_cover">
                        <img
                          :src="v.cover_url"
                          class="cover"
                        />
                      </div>
                      <div class="titleBox">
                        <div class="course_title">
                          <div class="cn">{{ v.name }}</div>
                          <div class="en">{{ v.name_en }}</div>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
            </div>
            <div class="series_type2_con" v-if="subject.type == 2">
              <div class="cover_con">
                <img :src="subject.courseList[0].cover_url" alt="" class="cover" v-if="subject.courseList && subject.courseList.length">
              </div>
              <div class="des_con">
                <p class="cn">{{subject.describe}}</p>
                <p class="en">{{subject.describe_en}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <img src="../img/chineseCultureVideoExhibition2025/new_2024/footer.png" />
      <div class="copyright">Copyright © ChinesePlus</div>
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <video
              :src="currentVideoUrl"
              id="liveVideo"
              autoplay
              controls
              controlsList="nodownload"
            ></video>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Qs from "qs";
import language from "./common/language";
export default {
  name: "chinesebridge",
  components: {
    language,
  },
  metaInfo() {
    return {
      title: "魅力中文，中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content:
            "魅力中文，中央广播电视总台精品节目展播",
        },
        {
          name: "description",
          content:
            "魅力中文，中央广播电视总台精品节目展播",
        },
      ],
    };
  },
  data: function() {
    return {
      isChrome: true,
      isLogin: false,
      isPlay: false,
      currentVideoUrl: "",
      imgUrl: "",
      user: {
        username: "",
        email: "",
      },
      lang: "cn",
      isShowGuide: true,
      active: 0,
      subject_info: [],
      courseList: {},
      activeTab: 0,
      subject_id: null,
      subject_name: [],
      subject_subText: [],
      swiperOption: {
        // loop: true,
        // autoplay: true,
        spaceBetween: 20,
        speed: 500,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      showDetail: false,
    };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
  created() {
    // 专题获取数据
    this.getCollectList()
    // this.getZtInfo()
  },
  mounted() {
    this.customCheckLogin();
    this.checkChrome();
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll, false);

    let activeTab = this.$route.query.tab;
    if (activeTab) {
      this.activeTab = activeTab;
    }
  },
  destroy() {
    // 移除监听器
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // 登录
    toLogin() {
      window.location.href =
        this.baseUrl +
        "user/api/login?" +
        "callback=" +
        encodeURIComponent(window.location.href);
    },
    // 注册
    toRegister() {
      window.location.href =
        "https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=" +
        encodeURIComponent(window.location.href);
    },
    // 检查是否登录 获取用户信息
    customCheckLogin() {
      this.checkLogin()
        .then((res) => {
          if (res.data.success) {
            this.isLogin = true;
            this.user = res.data.data;
          } else {
            this.isLogin = false;
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },
    // 退出登录
    toLogOut() {
      this.$utils.get("/user/api/logout").then((res) => {
        if (res.data.success) {
          this.isLogin = false;
        }
      });
    },
    getZtInfo () {
      this.$utils.get("/subject/subject/readbyalias", {
        alias: '2025mlzw',
      })
      .then((res) => {
        if (res.data.success) {
          this.ztInfo = res.data.data
        }
      })
    },
    goDetail (item, i) {
      this.$router.push({
        path: '/pcpage/cmgp2025_detail',
        query: {
          collection_id: item.id,
          videoIndex: i
        }
      })
      this.showDetail = true
    },
    getCollectList () {
      this.$utils.get("/subject/lesson_Collection/getlist", {
        limit: 999,
        alias: '2025mlzw',
      })
      .then((res) => {
        if (res.data.success) {
          this.subject_info = res.data.data.list
          this.getAllInfo()
        }
      })
    },
    async getAllInfo() {
      this.subject_info.forEach((item) => {
        // if (item.type == 1) {
          this.getSubjectInfo(item);
        // }
      });
    },

    getSubjectInfo(item) {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: item.id,
          order: 'sort',
          limit: 30
        })
        .then((res) => {
          if (res.data.success) {
            item.courseList = res.data.data.list
            this.$forceUpdate()
          }
        })
    },

    //排序
    compare(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },

    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".classBox1");
      // console.log(navContents)

      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop = document.documentElement.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      // console.log('top', scrollTop, offsetTopArr)
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        // console.log('clientHeight', offsetTopArr[n] , navContents[n].clientHeight )
        if (scrollTop >= offsetTopArr[n] - navContents[n].clientHeight) {
          // console.log('clientHeight',navContents[n].clientHeight)
          navIndex = n;
        }
      }
      if (scrollTop + clientHeight == scrollHeight) {
        navIndex = offsetTopArr.length - 1;
      }
      this.active = navIndex;
    },

    goAnchor(selector) {
      // console.log('#'+ selector)
      this.$el.querySelector("#" + selector).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },

    //播放课程
    replay(url, cover) {
      // console.log(url)
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function() {
        //
        $("#liveVideo").bind("contextmenu", function() {
          return false;
        }); //为video添加禁止右键另存为操作
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    },
    checkChrome() {
      var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
      if (!isChrome) {
        this.isChrome = false;
      }
    },
  }
};
</script>

<style scoped lang="scss">
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  // background-color: #ebf0f9;
  // background: linear-gradient(to right, #def3fd61, #ffdae23d);
  user-select: none;
  background: url('../img/chineseCultureVideoExhibition2025/content_bg.png') no-repeat center;

  .agentTip {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #ffe6a1;
    text-align: center;
    position: absolute;
    z-index: 5;
    color: #c40000;
  }

  .agentTip .closeTip {
    position: absolute;
    right: 24px;
    top: 0px;
    font-size: 30px;
    color: #282828;
    cursor: pointer;
  }

  .header_banner {
    position: relative;
    z-index: -1;
    background-image: url(../img/chineseCultureVideoExhibition2025/new_2024/banner.png);
    height: 600px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    header {
      position: absolute;
      height: 50px;
      line-height: 50px;
      z-index: 2;
      // border-bottom: 1px solid rgba(#fff, 0.3);
      top: 0;
      width: 100%;
      margin: auto;
      color: #fff;

      .center {
        color: #8590cc;
        width: 1200px;
        margin: auto;

        a {
          color: #8590cc;
          margin-right: 15px;
          // opacity: 0.8;
        }
      }

      .left {
        float: left;
      }

      .right {
        line-height: 50px;
        float: right;
        margin-right: -55px;

        img {
          vertical-align: text-top;
          margin-right: 15px;
        }

        .loginCon {
          display: inline-block;
          margin-left: 30px;

          span {
            cursor: pointer;
          }

          .username {
            margin-right: 12px;
          }
        }
      }
    }

    .infoCon {
      .centerBg {
        width: 1200px;
        margin: auto;
        position: absolute;
        top: 20px;
        left: 90px;
        right: 0;

        .left {
          float: left;
          margin-top: 20px;
        }

        .right {
          float: right;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 1400px;
    // height: 2860px;
    margin: auto;
    margin-top: -30px;

    .leftBox {
      width: 20%;
      height: fit-content;
      margin-left: -105px;
      text-align: end;
      border-right: 1px solid rgb(138, 138, 138);
      position: sticky;
      top: 80px;

      .box {
        display: flex;
        flex-direction: column;
        margin-right: -33px;
        margin-top: 15px;
        margin-bottom: 15px;

        .titleBox {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          cursor: pointer;

          .title {
            padding: 7px 10px;
            display: flex;
            flex-direction: column;
            margin-right: 45px;

            .title_cn {
              font-size: 18px;
              line-height: 30px;
              color: #364347;
            }

            .title_en {
              font-size: 12px;
              font-family: DINCond-Medium;
              color: #93a4aa;
            }
          }

          .icon {
            width: 55px;
            height: 21px;
            display: none;
          }
        }

        .titleBox.active {
          .title {
            margin-right: 15px;
            .title_cn {
              font-weight: bold;
              color: #973300;
            }
            .title_en {
              color: #973300;
            }
          }

          .icon {
            display: block;
          }
        }
      }
    }

    .rightBox {
      width: 80%;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-left: 110px;
      margin-bottom: 370px;
      margin-top: -90px;

      .projectProfile {
        position: relative;
        background: url(../img/chineseCultureVideoExhibition2025/kuang.png) no-repeat center;
        background-size: 100% 100%;
        margin-bottom: 30px;
        &.detail {
          .box {
            .text {
              margin-top: 10px;
              padding-left: 20px;
              padding-right: 20px;
            }
            .text2 {
              padding-left: 20px;
              padding-right: 20px;
            }
          }
        }
        .kuang1 {
          position: absolute;
          margin-top: 10px;
          z-index: 100;
        }
        .icon3 {
          position: absolute;
					top: 0;
        }
        .icon4 {
          position: absolute;
          bottom: 15px;
          right: 45px;
        }

        .box {
          width: 95%;
          // height: 250px;
          z-index: 10;
          margin: auto;
          margin-top: 10px;
          margin-bottom: 40px;
          .name_cn {
            font-size: 30px;
            font-weight: bold;
            color: #282828;
            margin-bottom: 10px;
            padding-left: 20px;
            padding-top: 20px;
          }
          .name_en {
            font-size: 18px;
            font-weight: bold;
            color: #93a4aa;
            padding-left: 20px;

          }

          .text {
            font-size: 16px;
            color: #282828;
            padding-top: 18px;
            padding-left: 35px;
            padding-right: 55px;
            margin-top: 25px;
            line-height: 26px;
            text-align: justify;
            text-indent: 2em;
          }

          .text2 {
            font-size: 15px;
            color: #282828;
            padding-left: 35px;
            padding-right: 55px;
            line-height: 24px;
						padding-bottom: 10px;
            text-align: justify;
            // text-indent:2em;
          }
        }
      }

      .video_wrap {
        .video_cover {
          display: block;
          width: 1100px;
          height: 619px;
          border: solid 2px #e0ac68;
          margin-bottom: 25px;
        }
        .video_list {
          margin-bottom: 30px;
          overflow: hidden;
          li {
            width: 71px;
            height: 71px;
            float: left;
            margin-right: 15px;
            border-radius: 10px;
            background-image: linear-gradient(0deg, 
              rgba(231, 217, 206, 1) 0%, 
              #f8f4f1 100%);
            border: 1px solid rgba(186,159,125,1);
            font-size: 40px;
            color: #a1896b;
            font-weight: bold;
            line-height: 70px;
            text-align: center;
            cursor: pointer;
          }
          .link {
            height: 73px;
            float: left;
            padding: 0 26px;
            box-sizing: border-box;
            border-radius: 10px;
            background-image: linear-gradient(0deg, 
              rgba(231, 217, 206, 1) 0%, 
              #f8f4f1 100%);
            border: 1px solid rgba(186,159,125,1);
            display: flex;
            align-items: center;
            cursor: pointer;
            .link_icon {
              margin-right: 15px;
            }
            .name_con {
              color: #a1896b;
              font-weight: bold;
              .cn {
                font-size: 18px;
              }
              .en {
                font-size: 16px;
              }
            }
          }
        }
      }

      .classBox {
        margin-bottom: 50px;
        .series_info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .info_left {
            .cloud_con {
              width: 136px;
              height: 100px;
              background: url(../img/chineseCultureVideoExhibition2025/cloud.png) no-repeat center;
              background-position-y: bottom;
              position: relative;
              float: left;

              .serise_icon_con {
                position: absolute;
                left: 25px;
                top: 15px;
                border: solid 3px #ffffff;
                img {
                  border-radius: 6px;
                  width: 60px;
	                height: 60px;
                  display: block;
                }
              }
            }
            .name_con {
              float: left;
              margin-top: 25px;
              margin-left: -30px;
              .cn {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 30px;
                color: #364347;
                margin-bottom: 4px;
              }
              .en {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 16px;
                color: #93a4aa;
              }
            }
          }
          .look_detail_icon {
            cursor: pointer;
            width: 208px;
            height: 30px;
          }
        }

        .text_cn {
          font-size: 16px;
          color: #5e696d;
          line-height: 24px;
          margin-top: 20px;
          margin-bottom: 5px;
        }

        .text_en {
          font-size: 14px;
          color: #5e696d;
          line-height: 20px;
          // margin-bottom: 20px;
        }

        .swiper_con {
          margin-top: 25px;
          margin-left: 0rem;
          position: relative;

          .swiper-container {
            position: unset;
          }

          .swiper {
            .swiper-slide {
              width: 3.6rem !important;

              .swiperBox {
                overflow: hidden;
              }
            }

            .video_con {
              width: 3.6rem;

              .huan_icon {
                display: block;
                // position: absolute;
                width: 0.78rem;
                bottom: 0;
                margin-top: -2rem;
                margin: auto;
                margin-top: -2rem;
                position: relative;
                z-index: 3;
              }

              .video_name_con {
                width: 4.8rem;
                height: 1.1rem;
                line-height: 1.2rem;
                font-weight: bold;
                background-color: #04c7de;
                border-radius: 0.2rem;
                border: solid 0.04rem #000000;
                font-family: HYJiJinTiW;
                text-align: center;
                font-size: 0.3rem;
                color: #ffffff;
                margin: auto;
                position: relative;
                z-index: 2;
                margin-top: -0.4rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                padding: 0 0.2rem;
                box-sizing: border-box;
              }

              .video_cover {
                width: 3.6rem;
                height: calc(3.4rem / (16 / 9));
                background-color: #f6453f;
                // border-radius: .2rem;
                // border: solid .04rem #000000;
                // overflow: hidden;
                // margin-top: -.4rem;

                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                }
              }

              .titleBox {
                position: absolute;
                height: 55px;
                margin-top: -55px;
                width: 100%;
                color: #fff;
                background-color: #55565775;
                text-align: left;
                z-index: 100;
                display: flex;
                align-items: center;

                .course_title {
                  padding: 10px 20px;

                  .cn {
                    font-size: 16px;
                  }

                  .en {
                    margin-top: 4px;
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .swiper-button-prev {
            background-image: url(../img/chineseCultureVideoExhibition2025/prev.png);
            position: absolute;
            left: -75px;
            top: 90px;
          }

          .swiper-button-next {
            background-image: url(../img/chineseCultureVideoExhibition2025/next.png);
            right: -75px;
            top: 90px;
          }
        }

        .series_type2_con {
          overflow: hidden;
          margin-top: 15px;
          .cover_con {
            width: 352px;
	          height: 220px;
            display: block;
            float: left;
            margin-right: 22px;
          }
          .cover {
            display: block;
            width: 100%;
            height: 100%;
          }
          .des_con {
            font-size: 14px;
            color: #5e696d;
            line-height: 24px;
            float: left;
            width: calc(100% - 22px - 352px);
            .cn {
              margin-bottom: 13px;
              display: -webkit-box;             /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 4;            /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden;                 /* 隐藏超出的内容 */
            }
            .en {
              line-height: 20px;
              display: -webkit-box;             /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 5;            /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden;                 /* 隐藏超出的内容 */
            }
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;

    .copyright {
      position: absolute;
      bottom: 140px;
      width: 100%;
      text-align: center;
      font-weight: 600;
    }

    img {
      width: 100%;
    }
  }

  #videoPlayWrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }

  #videoPlayWrapper .closeVideo {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
  }

  .videoContent {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .videoContainer {
    text-align: center;
    width: 100%;
  }

  .videoContainer video {
    width: 62%;
  }

  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
}

// 110%
@media screen and (max-width: 1750px) {
  .mainPage .header_banner {
    height: 560px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 4rem !important;

        .video_con {
          width: 4rem;

          .video_cover {
            width: 4rem;
            height: calc(4rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .footer {
    margin-top: -360px;
    .copy {
      bottom: 100px;
    }
  }
}

// 125%
@media screen and (max-width: 1540px) {
  .mainPage .header_banner {
    height: 540px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 4.5rem !important;

        .video_con {
          width: 4.5rem;

          .video_cover {
            width: 4.5rem;
            height: calc(4.3rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .footer {
    margin-top: -400px;
  }
}

// 150%
@media screen and (max-width: 1280px) {
  .mainPage .header_banner {
    height: 410px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 5rem !important;

        .video_con {
          width: 5rem;

          .video_cover {
            width: 5rem;
            height: calc(4.7rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .header_banner .infoCon .centerBg {
    transform: scale(0.7);
    top: -20px;
    left: 130px;
  }

  .projectProfile {
    transform: scale(0.9);
    margin-left: -100px;
  }

  .mainPage .content {
    .leftBox {
      transform: scale(0.9);
      left: -50px;
      top: 0;
    }

    .rightBox {
      transform: scale(0.9);
      margin-top: -140px;
      margin-left: 70px;
    }

    // height: 3000px;
    // transform: scale(0.8);
  }
}
</style>
